module.exports = __webpack_public_path__ + "static/media/server-down.3537602c.png";